type ProductSchemaProps = {
  itemName: string;
  itemImgUrlPerColor: string[];
  itemColors: string[];
  itemDescription: string;
  itemSku: string;
  itemUrl: string;
  itemPrice: string;
};

type Brand = {
  '@type': string;
  name: string;
};

type Offers = {
  '@type': string;
  url: string;
  availability: string;
  itemCondition: string;
  price: string;
  priceCurrency: string;
};

type ProductSchema = {
  '@context': string;
  '@type': string;
  name: string;
  image: string[];
  description: string;
  sku: string;
  color: string[];
  brand: Brand;
  offers: Offers;
};

const getProductSchema = ({
  itemName,
  itemImgUrlPerColor,
  itemColors,
  itemDescription,
  itemSku,
  itemUrl,
  itemPrice,
}: ProductSchemaProps): ProductSchema => ({
  '@context': 'https://schema.org/',
  '@type': 'Product',
  name: itemName,
  image: itemImgUrlPerColor,
  description: itemDescription,
  sku: itemSku,
  color: itemColors,
  brand: {
    '@type': 'Brand',
    name: 'Zola',
  },
  offers: {
    '@type': 'Offer',
    url: itemUrl,
    availability: 'https://schema.org/InStock',
    itemCondition: 'https://schema.org/NewCondition',
    price: itemPrice,
    priceCurrency: 'USD',
  },
});

export default getProductSchema;
